module.exports = __webpack_public_path__ + "media/images/unavailable-feature-bg-c5c76e5b.jpg";